// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.setup-student-selection .selection-header {
  margin-bottom: 24px;
}
.setup-student-selection .selection-header h5 {
  color: #0669B3;
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 8px;
}
.setup-student-selection .selection-header p {
  color: #0A4064;
  font-size: 0.95rem;
  margin: 0;
}
.setup-student-selection .filter-section {
  margin-bottom: 16px;
}
.setup-student-selection .filter-section label {
  color: #0669B3;
  display: block;
  font-size: 0.95rem;
  font-weight: 600;
  margin-bottom: 6px;
}
.setup-student-selection .filter-section input {
  border: 1px solid #808080;
  border-radius: 5px;
  font-size: 14px;
  padding: 8px 12px;
  width: 100%;
  max-width: 400px;
}
.setup-student-selection .filter-section input:focus {
  border-color: #0669B3;
  outline: none;
}
.setup-student-selection .table-container {
  border: 1px solid #D1D3D4;
  border-radius: 5px;
  max-height: 400px;
  overflow-y: auto;
  margin-bottom: 16px;
}
.setup-student-selection .table-container table {
  border-collapse: separate;
  border-spacing: 0;
  margin: 0;
  width: 100%;
}
.setup-student-selection .table-container table thead {
  position: sticky;
  top: 0;
  z-index: 10;
}
.setup-student-selection .table-container table thead tr th {
  background-color: #c0def0;
  border: none;
  border-bottom: 1px solid #D1D3D4;
  color: #0A4064;
  font-size: 0.95rem;
  font-weight: 500;
  padding: 12px 8px;
  text-align: left;
}
.setup-student-selection .table-container table thead tr th:first-child {
  border-top-left-radius: 5px;
  text-align: center;
  width: 50px;
}
.setup-student-selection .table-container table thead tr th:last-child {
  border-top-right-radius: 5px;
}
.setup-student-selection .table-container table thead tr th button {
  background: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
  font: inherit;
  padding: 0;
  text-align: left;
  width: 100%;
}
.setup-student-selection .table-container table thead tr th button .icon-container {
  display: inline-flex;
  flex-direction: column;
  margin-left: 5px;
  vertical-align: middle;
}
.setup-student-selection .table-container table tbody tr:hover {
  background-color: rgba(192, 222, 240, 0.3);
}
.setup-student-selection .table-container table tbody tr.disabled-row {
  opacity: 0.5;
  cursor: not-allowed;
}
.setup-student-selection .table-container table tbody tr td {
  border-bottom: 1px solid #D1D3D4;
  padding: 12px 8px;
}
.setup-student-selection .table-container table tbody tr td:first-child {
  text-align: center;
}
.setup-student-selection .table-container table tbody tr td input[type=checkbox] {
  cursor: pointer;
  height: 16px;
  width: 16px;
}
.setup-student-selection .table-container table tbody tr td input[type=checkbox]:disabled {
  cursor: not-allowed;
}
.setup-student-selection .selection-summary {
  color: #0A4064;
  font-size: 1rem;
  font-weight: 600;
  margin-top: 12px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/SetupStudentSelection.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AADI;EACI,mBAAA;AAIR;AAFQ;EACI,cD0BC;ECzBD,kBAAA;EACA,gBAAA;EACA,kBAAA;AAIZ;AADQ;EACI,cDLF;ECME,kBAAA;EACA,SAAA;AAGZ;AACI;EACI,mBAAA;AACR;AACQ;EACI,cDSC;ECRD,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AACZ;AAEQ;EACI,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;AAAZ;AAEY;EACI,qBDPH;ECQG,aAAA;AAAhB;AAKI;EACI,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAHR;AAKQ;EACI,yBAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;AAHZ;AAKY;EACI,gBAAA;EACA,MAAA;EACA,WAAA;AAHhB;AAMoB;EACI,yBDvDZ;ECwDY,YAAA;EACA,gCAAA;EACA,cD5Dd;EC6Dc,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAJxB;AAMwB;EACI,2BAAA;EACA,kBAAA;EACA,WAAA;AAJ5B;AAOwB;EACI,4BAAA;AAL5B;AAQwB;EACI,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;AAN5B;AAQ4B;EACI,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;AANhC;AAeoB;EACI,0CAAA;AAbxB;AAgBoB;EACI,YAAA;EACA,mBAAA;AAdxB;AAiBoB;EACI,gCAAA;EACA,iBAAA;AAfxB;AAiBwB;EACI,kBAAA;AAf5B;AAkBwB;EACI,eAAA;EACA,YAAA;EACA,WAAA;AAhB5B;AAkB4B;EACI,mBAAA;AAhBhC;AAyBI;EACI,cDpIE;ECqIF,eAAA;EACA,gBAAA;EACA,gBAAA;AAvBR","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n\n.setup-student-selection {\n    .selection-header {\n        margin-bottom: 24px;\n\n        h5 {\n            color: $pearl-blue;\n            font-size: 1.25rem;\n            font-weight: 700;\n            margin-bottom: 8px;\n        }\n\n        p {\n            color: $dk-blue;\n            font-size: 0.95rem;\n            margin: 0;\n        }\n    }\n\n    .filter-section {\n        margin-bottom: 16px;\n\n        label {\n            color: $pearl-blue;\n            display: block;\n            font-size: 0.95rem;\n            font-weight: 600;\n            margin-bottom: 6px;\n        }\n\n        input {\n            border: 1px solid $grey3;\n            border-radius: 5px;\n            font-size: 14px;\n            padding: 8px 12px;\n            width: 100%;\n            max-width: 400px;\n\n            &:focus {\n                border-color: $pearl-blue;\n                outline: none;\n            }\n        }\n    }\n\n    .table-container {\n        border: 1px solid $grey1;\n        border-radius: 5px;\n        max-height: 400px;\n        overflow-y: auto;\n        margin-bottom: 16px;\n\n        table {\n            border-collapse: separate;\n            border-spacing: 0;\n            margin: 0;\n            width: 100%;\n\n            thead {\n                position: sticky;\n                top: 0;\n                z-index: 10;\n\n                tr {\n                    th {\n                        background-color: $pale-blue;\n                        border: none;\n                        border-bottom: 1px solid $grey1;\n                        color: $dk-blue;\n                        font-size: 0.95rem;\n                        font-weight: 500;\n                        padding: 12px 8px;\n                        text-align: left;\n\n                        &:first-child {\n                            border-top-left-radius: 5px;\n                            text-align: center;\n                            width: 50px;\n                        }\n\n                        &:last-child {\n                            border-top-right-radius: 5px;\n                        }\n\n                        button {\n                            background: transparent;\n                            border: none;\n                            color: inherit;\n                            cursor: pointer;\n                            font: inherit;\n                            padding: 0;\n                            text-align: left;\n                            width: 100%;\n\n                            .icon-container {\n                                display: inline-flex;\n                                flex-direction: column;\n                                margin-left: 5px;\n                                vertical-align: middle;\n                            }\n                        }\n                    }\n                }\n            }\n\n            tbody {\n                tr {\n                    &:hover {\n                        background-color: rgba($pale-blue, 0.3);\n                    }\n\n                    &.disabled-row {\n                        opacity: 0.5;\n                        cursor: not-allowed;\n                    }\n\n                    td {\n                        border-bottom: 1px solid $grey1;\n                        padding: 12px 8px;\n\n                        &:first-child {\n                            text-align: center;\n                        }\n\n                        input[type=\"checkbox\"] {\n                            cursor: pointer;\n                            height: 16px;\n                            width: 16px;\n\n                            &:disabled {\n                                cursor: not-allowed;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .selection-summary {\n        color: $dk-blue;\n        font-size: 1rem;\n        font-weight: 600;\n        margin-top: 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
